/* Morgan Stanley makes this available to you under the Apache License,
 * Version 2.0 (the "License"). You may obtain a copy of the License at
 *      http://www.apache.org/licenses/LICENSE-2.0.
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership. Unless required by applicable law or agreed
 * to in writing, software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions
 * and limitations under the License. */

import type { BrowserTypes } from '@finos/fdc3';

export const recommendedChannels: BrowserTypes.Channel[] = [
    {
        id: 'fdc3.channel.1',
        type: 'user',
        displayMetadata: {
            name: 'Channel 1',
            color: 'red',
            glyph: '1',
        },
    },
    {
        id: 'fdc3.channel.2',
        type: 'user',
        displayMetadata: {
            name: 'Channel 2',
            color: 'orange',
            glyph: '2',
        },
    },
    {
        id: 'fdc3.channel.3',
        type: 'user',
        displayMetadata: {
            name: 'Channel 3',
            color: 'yellow',
            glyph: '3',
        },
    },
    {
        id: 'fdc3.channel.4',
        type: 'user',
        displayMetadata: {
            name: 'Channel 4',
            color: 'green',
            glyph: '4',
        },
    },
    {
        id: 'fdc3.channel.5',
        type: 'user',
        displayMetadata: {
            name: 'Channel 5',
            color: 'cyan',
            glyph: '5',
        },
    },
    {
        id: 'fdc3.channel.6',
        type: 'user',
        displayMetadata: {
            name: 'Channel 6',
            color: 'blue',
            glyph: '6',
        },
    },
    {
        id: 'fdc3.channel.7',
        type: 'user',
        displayMetadata: {
            name: 'Channel 7',
            color: 'magenta',
            glyph: '7',
        },
    },
    {
        id: 'fdc3.channel.8',
        type: 'user',
        displayMetadata: {
            name: 'Channel 8',
            color: 'purple',
            glyph: '8',
        },
    },
];
